import { Component, OnInit, Input, ViewChild, ElementRef, TemplateRef, NgZone } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ItemsService } from 'src/app/shared/services/data/items.service';
import { ToastrService } from 'ngx-toastr';
import { ReturnsService } from 'src/app/shared/services/data/returns.service';
import { SettingsService } from 'src/app/shared/services/data/settings.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { AuthService } from 'src/app/shared/services/auth.service';
declare var SqPaymentForm: any; //magic to allow us to access the SquarePaymentForm lib
declare global {
  interface Window { AuthorizeNetIFrame: any; }
}
@Component({
  selector: 'app-payment-bridge',
  templateUrl: './payment-bridge.component.html',
  styleUrls: ['./payment-bridge.component.scss']
})
export class PaymentBridgeComponent implements OnInit {

  @Input() type: 'membership' | 'shipping' | 'return' = 'shipping';
  @Input() data;
  @Input() chargeList;
  @Input() finalCost;
  @Input() recipient;
  @Input() returnaddress;
  selectedPaymentOption = 0;
  loading = false;
  loadingText = "Processing Payment";
  submitted = false;
  @ViewChild('paypalForm', { static: false }) paypalForm: ElementRef;
  @ViewChild('authorizeNetForm', { static: false }) authorizeNetForm: ElementRef;
  @ViewChild('modalSquarePay', { static: false }) squareModalRef: NgbModalRef;
  totalAmount;
  serviceType;
  service;
  paymentId;
  paypalEndPoint;
  paypalBusinessAccount;
  paymentSubmitted = false;
  paymentForm; //this is our payment form object
  loadingSquare = false;
  apiBaseUrl: string;
  websiteUrl: string;
  paymentOptions = [];
  paymentComission = 0;
  totalValue;
  calculatedComission = 0;
  authorizeNetToken = "";
  authorizeNetEndPoint = "";
  authorizeSubmitted = false;
  comission = 0;
  cloudfronturl:string = environment.cloudfront;
  //modalCODTAC:TemplateRef<any>;
  @ViewChild('modalCODTAC', { static: false }) modalCODTAC: TemplateRef<any>;
  @ViewChild('modalANET', { static: false }) modalANET: TemplateRef<any>;
  @ViewChild('iframeAuthorizeNet', { static: false }) iframeAuthorizeNet: ElementRef;
  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private itemService: ItemsService,
    private returnService: ReturnsService,
    private settingsService: SettingsService,
    private toastr: ToastrService,
    private router: Router,
    private ngZone: NgZone,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.paypalEndPoint = environment.paypalEndPoint;
    this.paypalBusinessAccount = environment.paypalBusinessAccount;
    this.apiBaseUrl = environment.apiPaymentUrl;
    this.websiteUrl = environment.websiteUrl;
    this.authorizeNetEndPoint = environment.authorizeNetEndPoint;

    const user = this.authService.getStoredUserInfo();
    
    if(user.id == 30159)//30002)
    {
      this.settingsService.getPaymentOptionsAll().subscribe((list) => {
        this.paymentOptions = list;
      });
    }
    else
    {
      this.settingsService.getPaymentOptions().subscribe((list) => {
        this.paymentOptions = list;
      });
    }
   
    this.totalValue = this.finalCost;

    var that = this;
    (function () {
      if (!window.AuthorizeNetIFrame) window.AuthorizeNetIFrame = {};
      window.AuthorizeNetIFrame.onReceiveCommunication = function (querystr) {
        var params = parseQueryString(querystr);
        switch (params["action"]) {
          case "successfulSave":
            console.log('successfulSave');
            break;
          case "cancel":
            that.ngZone.run(()=>{
              that.authorizeNetToken = "";
              that.paymentSubmitted = false;
              that.authorizeSubmitted = false;
              that.submitted = false;
              that.loading = false;
            })
            console.log('cancel');
            break;
          case "resizeWindow":
            console.log('resizeWindow');
            break;
          case "transactResponse":
            var transResponse = JSON.parse(params['response']);
            console.log(transResponse);
            that.itemService.verifyAuthorizeNetPayment(transResponse.refId, transResponse.transId).subscribe((data: any) => {
              if(data.success)
                that.activeModal.close({ authorizeDone: 1, returnParams:data.message });
              else
                that.toastr.error('An error occurred on payment verificaiton');
            },err=>{
              swal.fire({
                title: 'An error occurred on payment verificaiton',
                html: err.error.title,
                icon: 'error'
              });
            });
            break;
        }
      };

      function parseQueryString(str) {
        var vars = [];
        var arr = str.split('&');
        var pair;
        for (var i = 0; i < arr.length; i++) {
          pair = arr[i].split('=');
          vars.push(pair[0]);
          vars[pair[0]] = unescape(pair[1]);
        }
        return vars;
      }
    }());

  }


  openTAC(content) {
    //console.log(content);
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'tas' })
      .result.then((result) => {
        console.log(result);
      }, (reason) => {
        console.log('Err!', reason);
      });
  }

  selectPaymentMethod(value) {

    if (value == 12 && this.type != 'shipping')
      return;

    this.selectedPaymentOption = value;
    const paymentOption = this.paymentOptions.find(x => x.id == this.selectedPaymentOption);
    //console.log(paymentOption);
    this.calculatedComission = (this.totalValue * (paymentOption.comission / 100));
    this.comission = paymentOption.comission;
    if (this.calculatedComission < paymentOption.minComission)
      this.calculatedComission = paymentOption.minComission;

    this.paymentComission = this.calculatedComission;
    this.finalCost = this.totalValue + this.calculatedComission;

    if (this.calculatedComission) {
      let feeIndex = this.chargeList.findIndex(x=> x.key == "Payment Type Fee");
      if(feeIndex < 0)
        this.chargeList.push({ key: "Payment Type Fee", value: this.calculatedComission });
      else{
        this.chargeList[feeIndex].value = this.calculatedComission;
      }
    }
    else {
      this.chargeList = this.chargeList.filter(x => x.key != "Payment Type Fee");
    }
  }

  submitForPaymentOptions(checkoutLink, token = "") {
    setTimeout(() => {

      if (this.selectedPaymentOption === 2) {
        this.paypalForm.nativeElement.submit();
        this.loading = false;
        this.paymentSubmitted = true;
      }
      else if (checkoutLink) {
        this.paymentSubmitted = true;
        window.location = checkoutLink;
      }
      else if (this.selectedPaymentOption === 13) {
        if (!token) {
          this.toastr.error('An error occurred on connecting credit card provider!');
          this.loading = false;
          this.paymentSubmitted = false;
        }
        else {

          let that = this;
          swal.fire({
            title: 'CC Processing Fee',
            html: `By clicking confirm below, you agree to pay a <strong>${this.comission}% fee ($${this.calculatedComission.toFixed(2)})</strong> for Visa, Mastercard, and American Express. If you do not agree, please feel free to use another payment method. 
            <br>
            <small>(For international cards, please enter your Card Information, First and Last Name, Billing Country, City, and Telephone Number.)</small>`,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Confirm',
            icon: 'info',
            showLoaderOnConfirm: true
          }).then((result) => {
            if (result.value) {
              this.authorizeNetToken = token;
              this.paymentSubmitted = true;
              this.authorizeSubmitted = true;
              //this.openTAC(this.modalANET);
              setTimeout(() => {
                //this.authorizeSubmitted = true;
                this.authorizeNetForm.nativeElement.submit();
              }, 250);
            }
            else
            {
              this.loading = false;
              this.submitted = false;
            }
          });

          

        }

      }

    }, 1500);
  }

  submitPaymentForCod() {
    if (this.selectedPaymentOption == 12 && this.type == 'shipping') {
      let that = this;
      this.itemService.validateCashOnDelivery(this.data).subscribe((res: any) => {
        swal.fire({
          title: 'Cash On Delivery is eligible',
          html: `By clicking confirm below, you agree to our <a class="btn-link" href="javascript:" id="btnCodTerms">COD Terms of Services</a>.
          Payment for your shipment will be due upon pickup and you agree to pay a COD
          fee of $${this.calculatedComission.toFixed(2)} for this shipment. Do you want to continue?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Confirm',
          //confirmButtonClass: 'success',
          showLoaderOnConfirm: true,
          icon: 'success',
          willOpen: () => {
            document.getElementById('btnCodTerms').addEventListener("click", function () {
              that.openTAC(that.modalCODTAC);
            });
          }
        }).then((result) => {
          if (result.value) {
            this.data.payableamount = this.finalCost;
            this.data.paymentMethod = this.selectedPaymentOption;
            this.itemService.createPackage(this.data).subscribe((res: any) => {
              swal.fire({
                title: `Package ${res.id} created successfully`,
                icon: 'success',
                didClose: function () {
                  that.activeModal.close({ codDone: 1 });
                }
              })
            }, err => {
              this.toastr.error(err.error.title);
              this.loading = false;
            });
          }
        });
      }, err => {
        //this.toastr.error(err.error.title);
        swal.fire({
          title: 'Cash On Delivery is not eligible',
          html: err.error.title,
          icon: 'error'
        });
        this.loading = false;
        return;
      });
    }
  }

  submitPayment() {

    if (this.loading)
      return;

    this.submitted = true;
    if (this.selectedPaymentOption)
      this.loading = true;

    this.data.payableamount = this.finalCost;
    this.data.paymentMethod = this.selectedPaymentOption;
    //console.log(this.data);

    if (this.type === 'shipping') {
      this.itemService.createPackage(this.data).subscribe((res: any) => {
        //console.log(res);
        //this.loading = false;
        this.totalAmount = res.totalCost;
        this.paymentId = res.id;
        this.serviceType = "Package Id";
        this.service = "Ship via Boombinere";
        if (this.selectedPaymentOption == 12) {
          this.toastr.error('Cash on Delivery not available');
        }
        else {
          this.submitForPaymentOptions(res.checkoutLink, res.token);
        }

      }, err => {
        this.toastr.error(err.error.title);
        this.loading = false;
      });
    }
    else if (this.type === "return") {
      this.returnService.confirmReturn(this.data).subscribe((res: any) => {
        //this.loading = false;
        this.totalAmount = res.totalAmount;
        this.paymentId = res.id;
        this.serviceType = "Return Id";
        this.service = "Return item to US address";

        this.submitForPaymentOptions(res.checkoutLink, res.token);

      }, err => {
        this.toastr.error(err.error.title);
        this.loading = false;
      });
    }
    else if (this.type === "membership") {
      this.settingsService.applyMembershipPlan(this.data).subscribe((res: any) => {
        //this.loading = false;
        this.totalAmount = res.totalAmount;
        this.paymentId = res.id;
        this.serviceType = "Membership Id";
        this.service = res.desc;

        this.submitForPaymentOptions(res.checkoutLink, res.token);

      }, err => {
        this.toastr.error(err.error.title);
        this.loading = false;
      })
    }
  }
}
